export const VueAxios = {
    vm: {},
    install(vue, instance) {
        if (this.installed) {
            return;
        }
        this.installed = true;

        vue.axios = instance;

        Object.defineProperties(vue.prototype, {
            axios: {
                get: function get() {
                    return instance;
                }
            },
            $http: {
                get: function get() {
                    return instance;
                }
            }
        });
    }
};
